import "./registrationDatatable.scss";
import {
    DataGrid,
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,
    gridFilteredSortedRowIdsSelector,
    selectedGridRowsSelector,

} from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { fetchRegistrationRows, registrationColumns, registrationRows } from "../../datatablesource";
import { serverURL } from "../../temp";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem } from "@mui/material";

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
        </GridToolbarContainer>
    );
}

const getSelectedRowsToExport = ({ apiRef }) => {
    const selectedRowIds = selectedGridRowsSelector(apiRef);
    if (selectedRowIds.size > 0) {
        return Array.from(selectedRowIds.keys());
    }

    return gridFilteredSortedRowIdsSelector(apiRef);
};

const RegistrationDatatable = () => {
    const [data, setData] = useState(registrationRows);
    const [adminData] = useState(JSON.parse(localStorage.getItem("adminData")));
    const [loading, setLoading] = useState(false);
    const [resultAlert, setResultAlert] = useState(false);
    const [successAlert, setSuccessAlert] = useState(false);
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const qValue = queryParams.get("q");
    const [rowCount, setRowCount] = useState(0);
    // const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    // const [filterModel, setFilterModel] = useState <GridFilterModel> ({
    //     items: [],
    // });
    // const [sortModel, setSortModel] = useState <GridSortModel> ([]);


    // useEffect(() => {
    //     const getData = async (page, limit) => {
    //         setLoading(true);
    //         const rows = await fetchRegistrationRows(page + 1, limit);
    //         setLoading(false);
    //         // console.log("row", rows)
    //         // console.log("Array.from(rows.data)", Array.from(rows.data))
    //         // console.log("Array.from(rows.totalRecords)", Array.from(rows.totalRecords))
    //         setData(Array.from(rows.data));
    //         setRowCount(rows.totalRecords);
    //     };
    //     getData(paginationModel.page, paginationModel.pageSize);
    //     console.log("adminData", adminData.id)
    // }, [paginationModel]);

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            try {
                // console.log("paginationModel", paginationModel)
                const rows = await fetchRegistrationRows(
                    page + 1,  // Convert to 1-based index for API
                    pageSize
                );
                console.log("Array.from(rows.data)", rows.data[0].registered_class)
                setData(Array.from(rows.data));
                setRowCount(rows.totalRecords);
            } catch (error) {
                console.error("Failed to fetch data:", error);
            }
            setLoading(false);
        };
        getData();
    }, [page, pageSize]); 

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const handleMenuOpen = (event,id) => {
        setSelectedRowId(id);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setSelectedRowId(null);
        setAnchorEl(null);
    };

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 80,
            renderCell: (params) => {
                const rowId = params.row.id;
                return (
                    <div className="cellAction">
                        {/* <Link to={`/registration/update/${params.row.id}?q=ALL`} style={{ textDecoration: "none" }}>
                            <div className="editButton">Edit</div>
                        </Link> */}
                        <div onClick={(event) => handleMenuOpen(event, rowId)}>
                            <MoreVertIcon />
                        </div>
                        <Menu
                            id="action-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl && selectedRowId === rowId)}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <MenuItem onClick={() => handleMenuClose()}>
                                <Link to={`/registration/update/${params.row.id}?q=ALL`} style={{ textDecoration: "none", color: "#7451f8" }}>
                                    <div>Edit</div>
                                </Link>
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuClose()}>
                                <a href={`/admit-card/${params.row.id}?q=ALL`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color:"#7451f8" }}>
                                    Admit Card
                                </a>
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuClose()}>
                                <a href={`/registration-slip/${params.row.id}?q=ALL`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color:"#7451f8" }}>
                                    Registration Slip
                                </a>
                            </MenuItem>
                        </Menu>
                    </div>
                );
            },
        },
    ];

    
    return (
        <div className="registrationDatatable">
            <div className="datatableTitle">
                <span>Registered Students</span>
                <Link to={`/registration/new?q=ALL`} className="link">Add New</Link>
            </div>
            {resultAlert && (
                <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert severity="error">Error: This Quiz didn't attempt by any user yet</Alert>
                </Stack>
            )}
            {successAlert && (
                <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert severity="success">The quiz result exported successfully</Alert>
                </Stack>
            )}
            {loading ? <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1> :
                <DataGrid
                    className="datagrid"
                    rows={data}
                    columns={actionColumn.concat(registrationColumns)}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => {
                        setPageSize(newPageSize);
                        setPage(0); // reset to first page when page size changes
                    }}
                    pagination
                    paginationMode="server"
                    rowCount={rowCount}
                    loading={loading}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    components={{
                        Toolbar: (adminData.id === 9) ? GridToolbar : CustomToolbar,
                    }}
                />

            }
        </div>
    );
};

export default RegistrationDatatable;